import { render } from "./InstanceTab.vue?vue&type=template&id=0c7a68f2&scoped=true"
import script from "./InstanceTab.vue?vue&type=script&lang=js"
export * from "./InstanceTab.vue?vue&type=script&lang=js"

import "./InstanceTab.vue?vue&type=style&index=0&id=0c7a68f2&lang=scss&scoped=true"
import "./InstanceTab.vue?vue&type=style&index=1&id=0c7a68f2&scoped=true&lang=css"

import exportComponent from "/home/biktorgj/Projects/Linube Cloud/Server_and_UI/ui-prod-4.22/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c7a68f2"]])

export default __exports__